import { PropTypes } from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJRichTextEditor from '../../../../common/components/FJRichTextEditor/FJRichTextEditor';
import { AI_PHOTO_EDITOR_INIT_NODES } from '../../../../redux/slices/FJSliceAIPhotoEditor';
import FJAIPromptIcon from '../../../../assets/svg/ai-prompt.svg?react';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import FJConstant from '../../../../constants/FJConstant';
import FJRequirementsUtil from '../../../../util/FJRequirementsUtil';
import FJTitleLine from '../../../../common/combineComponents/FJTitleLine/FJTitleLine';

import styles from './FJAIPhotoEditorPrompt.module.less';

const FJAIPhotoEditorPrompt = ({ value, onChange, onClickImprovePrompts, promptStatus, onCancel, maxLength }) => {
    const [currentLength, setCurrentLength] = useState(0);
    const handleInputChange = templateValue => {
        onChange(templateValue);
    };

    const slateEditorNodes = useMemo(() => {
        return value ?? AI_PHOTO_EDITOR_INIT_NODES;
    }, [value]);

    const handleImprovePrompts = () => {
        onClickImprovePrompts?.();
    };

    const handleCancel = () => {
        onCancel?.();
    };

    const isOverLength = useMemo(() => {
        return currentLength > maxLength;
    }, [currentLength, maxLength]);

    const handleKeyDown = useCallback(nodes => {
        if (Array.isArray(nodes) && nodes.length > 0) {
            const length = FJRequirementsUtil.getTextBySlateNodes(nodes)?.length ?? 0;
            setCurrentLength(length);
        }
    }, []);

    return (
        <div className={styles.container}>
            <FJTitleLine
                title={FJLocalStore._('prompt')}
                isShowHelp={false}
                isShowTry={false}
                style={{ marginTop: 0 }}
                isRequire
                renderRight={() => {
                    return (
                        <div className={`${styles.char_counter} ${isOverLength ? styles.over_length : ''}`}>
                            {currentLength}/{maxLength}
                        </div>
                    );
                }}
            />
            <div className={styles.input_container}>
                <FJRichTextEditor
                    value={slateEditorNodes}
                    onChange={handleInputChange}
                    placeholder={FJLocalStore._('describe-what-you-want-to-change-in-the-image')}
                    maxHeight={115}
                    minHeight={115}
                    autoFocus={false}
                    onKeyDown={handleKeyDown}
                />
                {promptStatus === FJConstant.PROGRESS && (
                    <div className={styles.ai_optimizing_box}>
                        <FJLoading className={styles.ai_optimizing_loading} />
                        <div className={styles.ai_optimizing}>{FJLocalStore._('ai-optimizing')}</div>
                        <div className={styles.ai_image_importing_cancel_btn} onClick={handleCancel}>
                            {FJLocalStore._('cancel')}
                        </div>
                    </div>
                )}
                <div className={styles.prompt_buttons}>
                    <div className={styles.inspire_me} onClick={handleImprovePrompts}>
                        <FJAIPromptIcon />
                        {FJLocalStore._('improve-prompts')}
                    </div>
                </div>
            </div>
        </div>
    );
};

FJAIPhotoEditorPrompt.propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func,
    currentLength: PropTypes.number,
    maxLength: PropTypes.number,
    onClickImprovePrompts: PropTypes.func,
    promptStatus: PropTypes.string,
    onCancel: PropTypes.func,
};

export default FJAIPhotoEditorPrompt;
